<template>
  <div class="size-full">
    <router-view />
    <PlanDrawer />
  </div>
  <InternetConnectionMonitor />
  <SessionTimeoutModal />
</template>

<script setup lang="ts">
  import { computed } from "vue"
  import { useTitle } from "@vueuse/core"
  import { useI18n } from "vue-i18n"
  import PlanDrawer from "@/components/plan/PlanDrawer.vue"
  import { useApplicationLocales } from "@versatile-credit-apply/sdk"
  import { useGroupComponentsTheme } from "@/themes"
  import { SessionTimeoutModal } from "@versatile-credit-apply/components/session"
  import { InternetConnectionMonitor } from "@versatile-credit-apply/components/device"

  useApplicationLocales()
  useGroupComponentsTheme()

  const { t } = useI18n()
  useTitle(computed(() => t("siteTitle.label")))
</script>
